import React from "react";
import ReactDOM from "react-dom/client";
import CoxdiackGroupApp from "./CoxdiackGroupApp";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CoxdiackGroupApp />
  </React.StrictMode>
);
